import { Upload } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InboxOutlined } from "@ant-design/icons";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getImageUploadEditValue } from "../../../../../../helpers/form";
import { getMainApiUrl, getAppHeader } from "../../../../../../services/BaseService";

const apiURL = getMainApiUrl();

const Style = styled.div`
  flex: 1;
`;

export default function ImageUpload({ data = {}, input = {}, onChange = () => { }, config }) {
  const { t } = useTranslation();
  const value = data[input.key];
  const values = getImageUploadEditValue(value)

  return (
    <Style>
      <Upload.Dragger
        accept="image/*"
        disabled={input.disabled}
        classList={!values || !values.length ? 'empty' : ''}
        action={`${apiURL}/upload`}
        maxCount={1}
        headers={{
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        }}
        defaultFileList={values}
        style={{ width: '100%' }}
        onChange={(e) => {
          onChange({ [input.key]: e });
          if (e.file && e.file.status && typeof config?.setLoading === 'function') {
            if (e.file.status === 'uploading') {
              config.setLoading(true);
            } else {
              config.setLoading(false);
            }
          }
        }}
      >
        <div style={{ width: '100%' }}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{t('Click or drag file to this area to upload')}</p>
          <p className="ant-upload-hint">
            {t('Support for a single or bulk upload.')}
          </p>
        </div>
      </Upload.Dragger>
    </Style>
  );
}
